import {
	AdminStationPortalLogRecord,
	GetLogsByCursorParams,
	getAdminStationPortalLogsByCursor,
} from "../../../services/StationPortalLogService";

/**
 * Backend kẹp trần 200 dòng mỗi lần gọi, và đó là CÓ CHỦ ĐÍCH — nó chặn ai đó
 * vô tình kéo cả triệu dòng. Nên không nâng trần chung; ta lật con trỏ theo mẻ.
 *
 * Trần cứng ở đây chỉ để tránh treo trình duyệt. Chạm trần thì PHẢI báo: lỗi
 * thật của bản cũ là cắt bớt trong im lặng, không phải con số 200.
 */
export const EXPORT_BATCH_SIZE = 200;
export const EXPORT_HARD_CAP = 20000;

export async function collectLogsForExport(
	params: GetLogsByCursorParams,
	onProgress: (count: number) => void
): Promise<{ rows: AdminStationPortalLogRecord[]; truncated: boolean; failed: boolean }> {
	const rows: AdminStationPortalLogRecord[] = [];
	let cursor: string | undefined = params.cursor;

	for (;;) {
		let batch: { data: AdminStationPortalLogRecord[]; limit: number; nextCursor: string | null };
		try {
			batch = await getAdminStationPortalLogsByCursor({
				...params,
				cursor,
				limit: EXPORT_BATCH_SIZE,
			});
		} catch (_err) {
			// Nợ Task 6: bản cũ để lỗi ném thẳng ra ngoài, làm mất luôn phần đã gom
			// được ở các mẻ trước — người dùng bấm Export, đợi cả phút, rồi tay
			// trắng. Một mẻ lỗi giữa chừng KHÔNG được xoá sạch những gì đã tải; trả
			// về phần đã có kèm cờ `failed` để nơi gọi báo rõ cho người dùng.
			return { rows, truncated: false, failed: true };
		}

		// Phòng thủ con trỏ kẹt phía server: trần cứng ở dưới đếm theo SỐ DÒNG, nên
		// nếu server trả một mẻ RỖNG nhưng vẫn kèm nextCursor khác rỗng (bug con trỏ
		// không nhích), số dòng không bao giờ tăng và trần không bao giờ chạm — vòng
		// lặp for(;;) sẽ chạy mãi, treo trình duyệt. Đây không phải ca bình thường
		// (server đúng luôn trả nextCursor: null khi hết dòng) — chỉ là lưới an toàn.
		if (batch.data.length === 0) {
			return { rows, truncated: false, failed: false };
		}

		rows.push(...batch.data);
		onProgress(rows.length);

		if (rows.length >= EXPORT_HARD_CAP) {
			// Chạm/vượt trần KHÔNG đồng nghĩa với bị cắt. Nếu tổng số dòng thật đúng
			// bằng bội số của trần (vd 20.000 = 100 mẻ x 200) và mẻ này cũng là mẻ
			// cuối thật (nextCursor rỗng), thì đã lấy đủ — báo "truncated" ở đây là
			// báo động giả, đúng thứ mà cả tính năng này sinh ra để chữa (chỉ ngược
			// chiều). Chỉ coi là CẮT THẬT khi: (a) vẫn còn nextCursor — nghĩa là còn
			// dữ liệu chưa lấy, hoặc (b) mẻ cuối làm số dòng vượt hẳn trần khiến ta
			// phải vứt bớt phần dư khi slice — dù nextCursor có rỗng hay không.
			const stillHasMoreData = Boolean(batch.nextCursor);
			const overflowedPastCap = rows.length > EXPORT_HARD_CAP;
			return {
				rows: rows.slice(0, EXPORT_HARD_CAP),
				truncated: stillHasMoreData || overflowedPastCap,
				failed: false,
			};
		}
		if (!batch.nextCursor) {
			return { rows, truncated: false, failed: false };
		}
		cursor = batch.nextCursor;
	}
}
